import { Navigate, Route, Routes } from "react-router-dom";
import { PublicEventDetailPage, PublicEventsPage, PublicSchedulePage, PublicTopPage } from "../pages/public/PublicPages";
import {
  FamilyHomePage,
  FamilySchedulePage,
  FamilyVideoDetailPage,
  FamilyVideosPage,
  NotificationsPage,
  StudentDetailPage
} from "../pages/family/FamilyPages";
import { TeacherAbsenceRequestPage, TeacherHomePage, TeacherOccurrenceDetailPage } from "../pages/teacher/TeacherPages";
import {
  AdminEnrollmentsPage,
  AdminEventsPage,
  AdminGuardianLinkRequestsPage,
  AdminGuardianLinksPage,
  AdminHomePage,
  AdminIntegrationsPage,
  AdminLessonDetailPage,
  AdminLessonsPage,
  AdminMembersPage,
  AdminOccurrenceDetailPage,
  AdminPoliciesPage,
  AdminRecurringSlotsPage,
  AdminScheduleMonthPage,
  AdminStudentDetailPage,
  AdminStudentsPage,
  AdminVideosPage
} from "../pages/admin/AdminPages";
import {
  ContactSettingsPage,
  EntryPage,
  LinkStudentConfirmPage,
  LinkStudentPage,
  LinkStudentRequestPage,
  NotFoundPage
} from "../pages/common/CommonPages";

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/t/demo-club" replace />} />

      <Route path="/t/:tenantSlug" element={<PublicTopPage />} />
      <Route path="/t/:tenantSlug/schedule" element={<PublicSchedulePage />} />
      <Route path="/t/:tenantSlug/events" element={<PublicEventsPage />} />
      <Route path="/t/:tenantSlug/events/:eventId" element={<PublicEventDetailPage />} />

      <Route path="/t/:tenantSlug/entry" element={<EntryPage />} />
      <Route path="/t/:tenantSlug/link-student" element={<LinkStudentPage />} />
      <Route path="/t/:tenantSlug/link-student/confirm" element={<LinkStudentConfirmPage />} />
      <Route path="/t/:tenantSlug/link-student/request" element={<LinkStudentRequestPage />} />
      <Route path="/t/:tenantSlug/settings/contact" element={<ContactSettingsPage />} />

      <Route path="/t/:tenantSlug/home" element={<FamilyHomePage />} />
      <Route path="/t/:tenantSlug/my-schedule" element={<FamilySchedulePage />} />
      <Route path="/t/:tenantSlug/students/:studentId" element={<StudentDetailPage />} />
      <Route path="/t/:tenantSlug/videos" element={<FamilyVideosPage />} />
      <Route path="/t/:tenantSlug/videos/:videoId" element={<FamilyVideoDetailPage />} />
      <Route path="/t/:tenantSlug/notifications" element={<NotificationsPage />} />

      <Route path="/t/:tenantSlug/teacher" element={<TeacherHomePage />} />
      <Route path="/t/:tenantSlug/teacher/occurrences/:occurrenceId" element={<TeacherOccurrenceDetailPage />} />
      <Route path="/t/:tenantSlug/teacher/absence-request/new" element={<TeacherAbsenceRequestPage />} />
      <Route path="/t/:tenantSlug/teacher/admin" element={<AdminHomePage />} />
      <Route path="/t/:tenantSlug/teacher/admin/students" element={<AdminStudentsPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/students/:studentId" element={<AdminStudentDetailPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/members" element={<AdminMembersPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/guardian-links" element={<AdminGuardianLinksPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/guardian-link-requests" element={<AdminGuardianLinkRequestsPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/lessons" element={<AdminLessonsPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/lessons/:lessonId" element={<AdminLessonDetailPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/recurring-slots" element={<AdminRecurringSlotsPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/enrollments" element={<AdminEnrollmentsPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/schedule-months/:yyyymm" element={<AdminScheduleMonthPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/occurrences/:occurrenceId" element={<AdminOccurrenceDetailPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/events" element={<AdminEventsPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/videos" element={<AdminVideosPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/policies" element={<AdminPoliciesPage />} />
      <Route path="/t/:tenantSlug/teacher/admin/integrations" element={<AdminIntegrationsPage />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
